<template>
	<assign-table
		ref="table"
		:items="items"
		:headers="headers"
		:loading="loading"
		stage="pick"
		@select="(value: Array<Object>) => emit('select', value)"
		@update="(value: ContractItem) => emit('update', value)" />
</template>

<script lang="ts" setup>
	import type { Header } from '@/data/types/datatable'
	import { ref } from 'vue'
	import AssignTable from '../../all/AssignTable.vue'
	import type { ContractItem } from '@/data/schema/contract-item'

	const table = ref()

	defineProps({
		items: {
			type: Array<ContractItem>,
			default: []
		},
		loading: Boolean
	})

	const headers: Header[] = [
		{ value: 'stock_status', text: 'Status', props: { width: 100 } },
		{ value: 'item_number', text: 'Item No', props: { sortable: true, width: 120 } },
		{ value: 'description', text: 'Item Description', props: { width: 250 } },
		{ value: 'type', text: 'Type', props: { sortable: true, width: 100 } },
		{ value: 'quantity_required', text: 'Qty Req', props: { sortable: true } },
		{ value: 'quantity_confirmed', text: 'Qty Picked', props: { sortable: true } },
		{ value: 'quantity_loaded', text: 'Qty Load', props: { sortable: true } },
		{ value: 'pick_status', text: 'Pick Number', props: { sortable: true } },
		{
			value: 'delivery_method',
			text: 'Del Method',
			props: { sortable: true, width: 150, showFilterMenu: false }
		},
		{ value: 'assigned', text: 'Assigned Pick', props: { width: 160 } },
		{ value: 'assigned_load', text: 'Assigned Load', props: { width: 160 } },
		{ value: 'notes', text: 'Notes' }
	]

	// Events
	const emit = defineEmits(['select', 'update'])

	// Expose
	defineExpose({ updateOperators })

	/**
	 * Exposed function to bulk update all operators
	 * @param operator string
	 */
	function updateOperators(operator: string) {
		table.value.updateOperators(operator)
	}
</script>
